import { GET_PAGED_QUANTITY_PACK_ARGS, GET_PAGED_QUANTITY_PACK_FIELD_NAME } from './queries';

// This list tells DFC which keys to use for caching
// more specifically this says to ignore the additionalQuantity key
const PAGED_QUANTITY_PACK_KEY_ARGS = GET_PAGED_QUANTITY_PACK_ARGS.filter(arg => arg !== 'additionalQuantity');

// See https://www.apollographql.com/docs/react/pagination/core-api
export const PAGED_QUANTITY_PACK_FIELD_POLICIES = {
  [GET_PAGED_QUANTITY_PACK_FIELD_NAME]: {
    keyArgs: PAGED_QUANTITY_PACK_KEY_ARGS,
    // read tells DFC how to read the cache; returning undefined indicates to fetch more
    read(existing, {
      args
    }) {
      var _existing$quantities;
      const additionalQuantity = (args === null || args === void 0 ? void 0 : args.additionalQuantity) || 0;
      const hasQuantityInCache = (existing === null || existing === void 0 || (_existing$quantities = existing.quantities) === null || _existing$quantities === void 0 ? void 0 : _existing$quantities[additionalQuantity]) !== undefined;
      return hasQuantityInCache ? existing : undefined;
    },
    // merge combines results for requests with the same keyArgs
    merge(existing, incoming) {
      if (!existing) {
        return incoming;
      }
      const merged = Object.assign({}, existing);
      const existingQuantities = (merged === null || merged === void 0 ? void 0 : merged.quantities) || {};
      const incomingQuantities = (incoming === null || incoming === void 0 ? void 0 : incoming.quantities) || {};
      merged.quantities = Object.assign({}, existingQuantities, incomingQuantities);
      return merged;
    }
  }
};